// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const classNames = require('classnames');
const cryptoJS = require('crypto-js');
// @ actions
const formActions = require('react-redux-form').actions;
const jointHoldersActions = require('actions/jointHoldersActions');
// @ utilities
const StringHelper = require('utilities/stringHelper');
const { recordEvent, PAGE_PRODUCT } = require('utilities/uTagging');
const { PATH_ADD_JOINHOLDER } = require('constants/uTagConstants/paths');

class Options extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnDelete = this.handleOnDelete.bind(this);
        this.buildDeleteButton = this.buildDeleteButton.bind(this);
        this.buildEditButton = this.buildEditButton.bind(this);
        this.handleOnEdit = this.handleOnEdit.bind(this);
        this.handleOnDeleteHc = this.handleOnDeleteHc.bind(this);
    }

    handleOnDelete() {
        const { userProfile, formActions, id, modelProp, jointHoldersActions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        jointHoldersActions.remove(
            {
                inviteToRemove: {
                    docNumber: userProfile[`${modelProp}docNumber`],
                    docType: StringHelper.changeDocType(userProfile[`${modelProp}documentType`]),
                    email: userProfile[`${modelProp}email`],
                    jointHolderType: userProfile[`${modelProp}accountType`],
                    lastname1: StringHelper.toFirstUppercase(userProfile[`${modelProp}lastName`]),
                    lastname2: userProfile[`${modelProp}secondLastName`]
                        ? StringHelper.toFirstUppercase(userProfile[`${modelProp}secondLastName`])
                        : '',
                    name: StringHelper.toFirstUppercase(userProfile[`${modelProp}name`]),
                    openDebitCard: userProfile[`${modelProp}openDebitCard`]
                        ? userProfile[`${modelProp}openDebitCard`]
                        : false,
                },
            },
            userProfile.accessToken,
            valid => {
                if (valid) {
                    const index = userProfile['jointHolderCount'].indexOf(id);
                    formActions.remove('userProfile.jointHolderCount', index);
                    formActions.remove('userProfile.jointHolderIsEditing', index);
                    formActions.change(`userProfile.jointholder_${id}_name`, '');
                    formActions.change(`userProfile.jointholder_${id}_lastName`, '');
                    formActions.change(`userProfile.jointholder_${id}_secondLastName`, '');
                    formActions.change(`userProfile.jointholder_${id}_documentType`, '');
                    formActions.change(`userProfile.jointholder_${id}_docNumber`, '');
                    formActions.change(`userProfile.jointholder_${id}_accountType`, '');
                    formActions.change(`userProfile.jointholder_${id}_email`, '');

                    // @TODO: Revisar el flujo de agregar/editar/eliminar intervinientes
                    // Lo siguiente funciona, por alguna razón cuando hay un interviniente y se elimina
                    // el userProfile.jointHolderCount.length sigue siendo 1 y no 0
                    if (userProfile.jointHolderCount.length === 1) {
                        formActions.change('userProfile.jointHolderEditable', 1);
                        formActions.push('userProfile.jointHolderCount', 1);
                        formActions.reset('userProfile.jointHolderAuthorizedList');
                        formActions.reset('userProfile.jointHolderAuthorizedList_option');
                    }
                    formActions.change('userProfile.jointHoldersError', false);

                    recordEvent(
                        PATH_ADD_JOINHOLDER,
                        PAGE_PRODUCT,
                        'intervinientes',
                        'eliminar',
                        '',
                        '',
                        '',
                        userProfile.investmentType,
                        docNumberEncrypted
                    );
                }
            }
        );
    }

    handleOnEdit() {
        const { formActions, id, handleOnEdit } = this.props;
        formActions.change('userProfile.jointHolderEditable', id);
        formActions.change('userProfile.jointHoldersError', false);
        handleOnEdit(id);
    }

    buildDeleteButton() {
        const { isStandByHC, dispensable } = this.props;
        const handleDelete = !isStandByHC ? this.handleOnDelete : this.handleOnDeleteHc;
        const iconsClass = classNames('icons icons--icon-delete-3', { icons__disabled: isStandByHC && !dispensable });
        const buttonClass = dispensable ? '' : 'not-active-joint-holders';

        return (
            <a
                href="#"
                className={buttonClass}
                onClick={event => {
                    event.preventDefault();
                    handleDelete();
                }}
            >
                <i className={iconsClass}></i>
            </a>
        );
    }

    handleOnDeleteHc() {
        const { formActions, id } = this.props;
        formActions.change('userProfile.jointHolderEditable', `deleteJointHolder_${id}`);
    }

    buildEditButton() {
        const { isStandByHC, editable } = this.props;
        const iconsClass = classNames('icons icons--icon-edit-2', { icons__disabled: isStandByHC && !editable });
        const buttonClass = editable ? '' : 'not-active-joint-holders';

        return (
            <a
                href="#"
                className={buttonClass}
                onClick={event => {
                    event.preventDefault();
                    this.handleOnEdit();
                }}
            >
                <i className={iconsClass}></i>
            </a>
        );
    }

    render() {
        const { userProfile, id } = this.props;

        return (
            <div key={`option${id}`}>
                <p>
                    {userProfile.jointHolderEditable !== id ? this.buildEditButton() : null}
                    {this.buildDeleteButton()}
                </p>
            </div>
        );
    }
}

Options.proptypes = {
    expanded: PropTypes.bool,
    id: PropTypes.number,
};

Options.defaultProps = {
    expanded: true,
};

module.exports.Options = connect(
    state => ({
        userProfile: state.userProfile,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
    })
)(Options);
